import React, { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { DatePickerProps } from './Types';
import InputLabel from './InputLabel';

const DatePickerInput = React.forwardRef<any, DatePickerProps>(
  (
    {
      placeholder = 'Select...',
      name,
      value = null,
      showTime = false,
      onChange,
      shape = 'squre',
      color = 'textPrimary',
      bg = 'white',
      label,
      required = false,
      maxDate,
      minDate,
    }: DatePickerProps,
    ref
  ) => {
    const [selectedDate, setDate] = useState<dayjs.Dayjs | null>(
      value ? dayjs(value) : null
    );
    const onSelect = (date: dayjs.Dayjs | null, dateString: string) => {
      setDate(date);
      onChange(name, date ? dayjs(date).toISOString() : '');
    };

    const { t } = useTranslation();

    useEffect(() => {
      setDate(value ? dayjs(value) : null);
    }, [value]);
    return (
      <div>
        {label && <InputLabel text={label} name={name} required={required} />}
        <DatePicker
          ref={ref}
          className={`input focus:ring-primary focus:border-primary block w-full   sm:text-sm border-gray-300  px-2 py-1 lg:py-2  align-middle   cursor-pointer  focus:ring-opacity-10 focus:ring-offset-0  ${
            shape === 'circle' ? 'rounded-full' : 'rounded-md'
          } bg-${bg} !text-${color}  `}
          placeholder={
            t(`inputs.placeholders.${placeholder}`, placeholder || '') as string
          }
          showTime={showTime}
          name={name}
          onChange={onSelect}
          onOk={(t) => {
            onChange(name, dayjs(t).toISOString());
          }}
          value={selectedDate}
          disabledDate={(current) => {
            const max = maxDate ? dayjs(maxDate) : null;
            const min = minDate ? dayjs(minDate) : null;
            if (max && min) {
              return current > max || current < min;
            }
            if (max) {
              return current > max;
            }
            if (min) {
              return current < min;
            }
            return false;
          }}
        />
      </div>
    );
  }
);

export default DatePickerInput;
